import { defineComponent as _defineComponent } from 'vue'
import { Pagination, Grid } from 'swiper'


export default /*@__PURE__*/_defineComponent({
  __name: 'Advantages',
  setup(__props, { expose: __expose }) {
  __expose();

const modules = [Pagination, Grid]

const breakpoints = {
  0: {
    slidesPerView: 1.4,
    spaceBetween: 20,
  },
  564: {
    slidesPerView: 2,
  },
  992: {
    slidesPerView: 3,
  },
  1200: {
    slidesPerView: 4,
    // grid: {
    //   rows: 4,
    // },
  },
}

const __returned__ = { modules, breakpoints, get Pagination() { return Pagination }, get Grid() { return Grid } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})